import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { formatSignedCurrency, formatPercent } from './format';
import { pnlColors } from './theme';

interface PnlTextProps extends Omit<TypographyProps, 'color'> {
  value: number | null | undefined;
  format?: 'currency' | 'percent';
}

/** Signed, colored P&L value. Sign + color together (color is never the only signal). */
const PnlText: React.FC<PnlTextProps> = ({ value, format = 'currency', sx, ...props }) => {
  if (value === null || value === undefined) {
    return <Typography component="span" color="text.secondary" sx={{ fontWeight: 700, ...sx }} {...props}>N/A</Typography>;
  }
  const text = format === 'percent' ? formatPercent(value) : formatSignedCurrency(value);
  const color = value > 0 ? pnlColors.gain : value < 0 ? pnlColors.loss : undefined;
  return (
    <Typography component="span" sx={{ color, fontWeight: 700, ...sx }} {...props}>{text}</Typography>
  );
};

export default PnlText;
